import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { keys } from 'lodash-es';
import { TextButton, useOverlayContext } from 'seagull';
import { useTableListContext } from 'seagull/components/TableList/TableList.utils';
import { FilterSmall } from 'seagull/icons';
import { getTestIds } from 'seagull/utils/TestIds';
import { MobileFilterList } from '../MobileFilterList/MobileFilterList';
import { isEmptyFilterValue } from '../TableFilters.utils';
export const GetMobileTableFiltersTID = (parentTestId)=>getTestIds(parentTestId);
function getSortableColumnIndices(columnDefs) {
    return columnDefs.map((col, index)=>({
            col,
            index
        })).filter((param)=>{
        let { col } = param;
        return col.sortable;
    }).map((param)=>{
        let { index } = param;
        return index;
    });
}
export const MobileTableFilters = (param)=>{
    let { testIdPrefix, filterLabels, filterConfig, selectedFilters, onRefresh, setSelectedFilters, filterGroups, mobile } = param;
    const { MobileTableFiltersTID } = useMemo(()=>GetMobileTableFiltersTID(testIdPrefix), [
        testIdPrefix
    ]);
    const { sort, setSort, columnDefs } = useTableListContext();
    const { showBottomSheet, hideBottomSheet } = useOverlayContext();
    const sortableColumnIndices = useMemo(()=>getSortableColumnIndices(columnDefs), [
        columnDefs
    ]);
    const activeFilterCount = keys(selectedFilters).filter((key)=>!isEmptyFilterValue(selectedFilters[key], filterConfig[key])).length;
    const triggerLabel = activeFilterCount > 0 ? "Filter (".concat(activeFilterCount, ")") : 'Filter';
    function handleTriggerClick() {
        showBottomSheet({
            content: /*#__PURE__*/ _jsx(MobileFilterList, {
                testId: testIdPrefix,
                filterLabels: filterLabels,
                filterConfig: filterConfig,
                initialDraftFilters: _object_spread({}, selectedFilters),
                initialDraftSort: sort,
                sortOptions: mobile === null || mobile === void 0 ? void 0 : mobile.sortOptions,
                sortableColumnIndices: sortableColumnIndices,
                filterGroups: filterGroups,
                formatFilterDescription: mobile === null || mobile === void 0 ? void 0 : mobile.formatFilterDescription,
                onApply: (draftFilters, draftSort)=>{
                    setSelectedFilters(draftFilters);
                    setSort(draftSort);
                    onRefresh(draftFilters, draftSort);
                    hideBottomSheet();
                }
            })
        });
    }
    return /*#__PURE__*/ _jsx(TextButton, {
        testId: MobileTableFiltersTID.TriggerButton(),
        underline: "none",
        prefixIcon: /*#__PURE__*/ _jsx(FilterSmall, {}),
        onClick: handleTriggerClick,
        children: triggerLabel
    });
};
